import {
  CREATE_PIRING_TRANSAKSI_SUCCESS,
  CREATE_PIRING_TRANSAKSI_FAIL,
  RETRIEVE_PIRING_TRANSAKSI_SUCCESS,
  RETRIEVE_PIRING_TRANSAKSI_FAIL,
  UPDATE_PIRING_TRANSAKSI_SUCCESS,
  UPDATE_PIRING_TRANSAKSI_FAIL,
  DELETE_PIRING_TRANSAKSI_SUCCESS,
  DELETE_PIRING_TRANSAKSI_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_PIRING_TRANSAKSI_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_PIRING_TRANSAKSI_SUCCESS:
      return payload;

    case RETRIEVE_PIRING_TRANSAKSI_FAIL:
      return [...datas];

    case UPDATE_PIRING_TRANSAKSI_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_PIRING_TRANSAKSI_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
